<!-- BattleRecords.vue -->
<template>
  <div class="battle-records-container" :class="{ 'dark': isDark }">
    <!-- 主控制栏 -->
    <div v-if="!hideHeader" class="records-header">
      <div class="header-left">
        <Button 
          v-if="currentView === 'replay'" 
          @click="backToList" 
          icon="ios-arrow-back"
          size="small"
          class="back-btn"
        >
          返回
        </Button>
        <!-- <span class="header-title">
          {{ currentView === 'summary' ? '自动战斗摘要' : '战斗回放' }}
        </span> -->
       
        <div v-if="!isMobile" class="replay-header-bar" >
          <div class="replay-info">
            <Icon type="ios-play-circle" size="18" color="#2d8cf0" />
            <span>{{ replayTitle }}</span>
          </div>
        </div>
      </div>
      <div class="header-actions">
        <ButtonGroup>
          <Button 
            @click="refreshData" 
            :loading="refreshing"
            icon="ios-refresh" 
            size="small"
            type="primary"
          >
            刷新
          </Button>
          <Button 
            @click="showSummaries" 
            icon="ios-list-box" 
            size="small"
            :type="currentView === 'summary' ? 'success' : 'default'"
          >
            摘要({{ recentSummaries.length }})
          </Button>
          <Button 
            @click="showLatestReplay" 
            icon="ios-play" 
            size="small"
            :type="currentView === 'replay' ? 'info' : 'default'"
            :disabled="!latestRecordForReplay"
          >
            回放
          </Button>
        </ButtonGroup>
        <ButtonGroup v-if="showReplayPicker" class="replay-picker">
          <Button
            v-for="(_, idx) in replayBattleOptions"
            :key="'replay-index-' + idx"
            size="small"
            :type="replaySelectedIndex === (idx + 1) ? 'primary' : 'default'"
            @click="selectReplayIndex(idx + 1)"
          >
            第{{ idx + 1 }}场
          </Button>
        </ButtonGroup>
      </div>

     
    </div>

    <!-- 视图1: 历史记录列表 -->
    <div v-show="currentView === 'list'" class="view-panel list-view battle-list-placeholder">
      <div class="list-stats">
        <span>共 {{ battleHistory.length }} 场历史战斗</span>
        <span v-if="autoCombatStatus.running" class="auto-info">
          自动战斗: {{ autoCombatStatus.currentCount }}/{{ autoCombatStatus.maxCount }} 场
        </span>
        <!-- 新增：详细统计信息 -->
        <div v-if="autoCombatStatus.running || autoCombatStatus.winCount > 0" class="combat-stats-detail">
          <Tag color="green" size="small">胜利 {{ autoCombatStatus.winCount || 0 }}</Tag>
          <Tag color="red" size="small">失败 {{ autoCombatStatus.loseCount || 0 }}</Tag>
          <Tag color="blue" size="small">胜率 {{ autoCombatStatus.winRate || '0%' }}</Tag>
          <Tag color="gold" size="small">
            <Icon type="logo-bitcoin" /> {{ formatNumber(autoCombatStatus.totalDropGold) || 0 }}
          </Tag>
          <Tag color="cyan" size="small">
            <Icon type="ios-timer-outline" /> 时均 {{ formatNumber(autoCombatStatus.goldPerHour) || 0 }}
          </Tag>
           <Tag color="purple" size="small" class="map-drop-trigger-tag">
              <span >
                <Icon type="ios-map" /> {{ autoCombatStatus.mapName }}
              </span>
            </Tag>
        </div>
      </div>
      <div class="battle-list-placeholder__body">
        <Button type="primary" size="small" @click="showSummaries">查看摘要</Button>
        <Button size="small" :disabled="!latestRecordForReplay" @click="showLatestReplay">查看回放</Button>
      </div>
    </div>

    <!-- 视图2: 自动战斗摘要列表 (循环展示 recentSummaries) -->
    <div v-show="currentView === 'summary'" class="view-panel summary-view">
      <!-- 新增：统计概览面板 -->
      <div v-if="autoCombatStatus.running || autoCombatStatus.winCount > 0" class="stats-overview">
        <div class="stats-card">
          <div class="stats-item">
            <div class="stats-value success">{{ autoCombatStatus.winCount || 0 }}</div>
            <div class="stats-label">胜利</div>
          </div>
          <div class="stats-item">
            <div class="stats-value fail">{{ autoCombatStatus.loseCount || 0 }}</div>
            <div class="stats-label">失败</div>
          </div>
          <div class="stats-item">
            <div class="stats-value rate">{{ autoCombatStatus.winRate || '0%' }}</div>
            <div class="stats-label">胜率</div>
          </div>
          <div class="stats-item">
            <div class="stats-value gold">{{ formatNumber(autoCombatStatus.totalDropGold) || 0 }}</div>
            <div class="stats-label">金币</div>
          </div>
          <div class="stats-item">
            <div class="stats-value exp">{{ formatNumber(autoCombatStatus.totalDropExp) || 0 }}</div>
            <div class="stats-label">修为</div>
          </div>
          <div class="stats-item">
            <div class="stats-value hourly">{{ formatNumber(autoCombatStatus.goldPerHour) || 0 }}</div>
            <div class="stats-label">时均金币</div>
          </div>
          <div class="stats-item wide" v-if="autoCombatStatus.mapName">
            <Poptip
              trigger="click"
              placement="bottom-end"
              transfer
              popper-class="map-drop-pop"
              @on-popper-show="handleMapDropPopoverShow"
            >
              <div class="stats-value map">
                <span class="map-drop-trigger-text">
                  <Icon type="ios-map" /> {{ autoCombatStatus.mapName }}
                </span>
              </div>
              <div slot="content" class="map-drop-panel">
                <div v-if="autoCombatStatus.dropItemsDesc !=null " class="map-drop-list">
                    {{ autoCombatStatus.dropItemsDesc }}
                </div>
                <div v-else class="map-drop-empty">暂无掉落信息</div>
              </div>
            </Poptip>
            <div class="stats-label">当前地图</div>
          </div>
        </div>
      </div>
      <div class="summary-header">
        <span>最近 {{ recentSummaries.length }} 次自动战斗摘要</span>
        <Button @click="backToList" icon="ios-close" size="small" type="text"></Button>
      </div>
      
      <div class="summary-list">
        <div
          v-for="(summary, index) in normalizedRecentSummaries"
          :key="summary.key || index"
          class="summary-item"
          :class="[summary.statusClass, { latest: summary.isLatest }]"
        >
          <div class="summary-content">
            <div class="summary-result">
               {{ summary.displayText }}
               <span style="color:red" v-if="summary.isLatest">new</span>
            </div>
          </div>
          <div class="summary-time">{{ summary.timeText }}</div>
        </div>
        
        <div v-if="recentSummaries.length === 0" class="empty-state">
          <Icon type="ios-pulse-outline" size="48" />
          <p>暂无自动战斗摘要</p>
          <span class="sub-text">启动自动战斗后将显示摘要</span>
        </div>
      </div>
      
      <!-- 自动战斗控制 -->
      
    </div>

    <!-- 视图3: 战斗回放 (使用 battle-process) -->
    <div v-show="currentView === 'replay'" class="view-panel replay-view">
      <div class="replay-toolbar">
        <div class="replay-toolbar-left">
          <Button size="small" @click="stepReplayBackward" :disabled="replayCursor <= 0">
            上一条
          </Button>
          <Button
            size="small"
            type="primary"
            @click="toggleReplayPlayback"
            :disabled="originalReplayRecordings.length === 0"
          >
            {{ replayPlaying ? '暂停' : (replayCursor > 0 ? '继续' : '播放') }}
          </Button>
          <Button size="small" @click="stepReplayForward" :disabled="replayCursor >= originalReplayRecordings.length">
            下一条
          </Button>
          <Button size="small" @click="restartReplay" :disabled="originalReplayRecordings.length === 0">
            重播
          </Button>
          <ButtonGroup v-if="showReplayPicker" class="replay-picker replay-picker-inline">
            <Button
              v-for="(_, idx) in replayBattleOptions"
              :key="'replay-toolbar-index-' + idx"
              size="small"
              :type="replaySelectedIndex === (idx + 1) ? 'primary' : 'default'"
              @click="selectReplayIndex(idx + 1)"
            >
              第{{ idx + 1 }}场
            </Button>
          </ButtonGroup>
        </div>
        <div class="replay-toolbar-right">
          <span class="replay-progress">进度 {{ replayCursor }}/{{ originalReplayRecordings.length }}</span>
          <ButtonGroup>
            <Button
              v-for="speed in replaySpeedOptions"
              :key="'speed-' + speed"
              size="small"
              :type="replaySpeed === speed ? 'primary' : 'default'"
              @click="setReplaySpeed(speed)"
            >
              {{ speed === 'all' ? '全部' : speed + 'x' }}
            </Button>
          </ButtonGroup>
          <Button
            size="small"
            icon="ios-stats"
            type="warning"
            @click="dpsModalVisible = true"
            :disabled="originalReplayRecordings.length === 0"
          >
            DPS统计
          </Button>
          <Button
            size="small"
            icon="ios-expand"
            @click="replayLogModal = true"
            :disabled="originalReplayRecordings.length === 0"
          >
            展开日志
          </Button>
        </div>
      </div>
      <div class="battle-stage battle-stage-replay">
        <div class="stage-column stage-column-monsters" v-if="replayMonsters.length > 0">
          <!-- <div class="stage-title">怪物</div> -->
          <div class="stage-list">
            <Poptip
              v-for="(item, index) in replayMonsters"
              :key="'replay-monster-' + (item.id || index)"
              trigger="hover"
              placement="top-start"
              word-wrap
              transfer
              popper-class="mud-pop"
              class="mud-pop-trigger"
            >
              <div
                class="mud-line"
                :class="{ defeated: getMonsterCurrentHp(item) <= 0 }"
              >
                <span class="mud-name"><span v-if="item.prefix!=0">⭐</span>{{ item.name || '怪物' }} </span>
                <span class="mud-value">{{ getMonsterCurrentHp(item) }}/{{ getMonsterMaxHp(item) }}</span>
              </div>
              <div slot="content" class="mud-detail">
                <p>名称 {{item.name}}</p>
                <p>类型 {{item.attackType == 1 ? "力道" : "灵力"}}</p>
                <p>前缀 {{item.prefix==0? "无" : item.prefix}}</p>
                <p>生命 {{ getMonsterCurrentHp(item) }}/{{ getMonsterMaxHp(item) }}</p>
                <p>攻击 {{ formatAttackDisplay(item, ['attackMin'], ['attackMax'], ['physicalAttack']) }}</p>
                <p>法力 {{ formatTooltipStat(item, ['mana']) }}</p>
                <p>物理防御 {{ formatTooltipStat(item, ['defence', 'defense']) }}</p>
                <p>法术防御 {{ formatTooltipStat(item, ['magicDefense']) }}</p>
                <p>暴击率 {{ formatTooltipPercent(item, ['explode', 'criticalHitValue']) }}</p>
                <p>暴击伤害 {{ formatTooltipPercent(item, ['criDamage', 'critDamage']) }}</p>
                <p>速度 {{ formatTooltipStat(item, ['speed', 'movingSpeed']) }}</p>
              </div>
            </Poptip>
          </div>
        </div>
        <div class="stage-column stage-column-allies">
          <!-- <div class="stage-title">我方</div> -->
          <div class="stage-list">
            <Poptip
              v-for="(item, index) in replayAlliesDisplay"
              :key="'replay-ally-' + (item._key || index)"
              trigger="hover"
              placement="top-start"
              word-wrap
              transfer
              popper-class="mud-pop"
              class="mud-pop-trigger"
            >
              <div
                class="mud-line"
                :class="{ defeated: item._currentHp <= 0 }"
              >
                <span class="mud-name"><span class="mud-tag">{{ item._group }}</span>{{ item._name }}</span>
                <span class="mud-value">{{ item._currentHp }}/{{ item._maxHp }}</span>
              </div>
              <div slot="content" class="mud-detail">
                <p>名称 {{ item._name }}</p>
                <p>生命 {{ item._currentHp }}/{{ item._maxHp }}</p>
                <p>根骨 {{ formatTooltipStat(item, ['physique', 'auraPhysique']) }}</p>
                <p>灵力 {{ formatTooltipStat(item, ['spirit', 'auraSpirit']) }}</p>
                <p>力道 {{ formatTooltipStat(item, ['dexterous', 'auraDexterity']) }}</p>
                <p>攻击 {{ formatAttackDisplay(item, ['attackMin', 'auraAttack'], ['attackMax'], ['physicalAttack', 'attack', 'auraAttack']) }}</p>
                <p>灵攻 {{ formatTooltipStat(item, ['magicAttack', 'auraMagicAttack']) }}</p>
                <p>法力 {{ formatTooltipStat(item, ['mana', 'auraMana']) }}</p>
                <p>物理防御 {{ formatTooltipStat(item, ['defense', 'defence', 'auraDefence']) }}</p>
                <p>法术防御 {{ formatTooltipStat(item, ['magicDefense', 'auraMagicDefence']) }}</p>
                <p>暴击率 {{ formatTooltipPercent(item, ['explode', 'criticalHitValue', 'auraExplode']) }}</p>
                <p>暴击伤害 {{ formatTooltipPercent(item, ['criDamage', 'critDamage', 'auraCalDamage']) }}</p>
                <p>命中率 {{ formatTooltipPercent(item, ['hitRate']) }}</p>
                <p>闪避率 {{ formatTooltipPercent(item, ['evade']) }}</p>
                <p>破甲 {{ formatTooltipPercent(item, ['armor']) }}</p>
                <p>连击 {{ formatTooltipPercent(item, ['combo']) }}</p>
                <p>反击 {{ formatTooltipPercent(item, ['counter']) }}</p>
                <p>速度 {{ formatTooltipStat(item, ['speed', 'movingSpeed', 'auraActionSpeed']) }}</p>
                <p v-if="getReplaySkillSummary(item)">技能 {{ getReplaySkillSummary(item) }}</p>
                <!-- <p>状态 {{ formatReplayUnitStatus(item) }}</p> -->
              </div>
            </Poptip>
          </div>
        </div>
      </div>
      <div class="replay-content-box replay-content-box--pc-adaptive">
        <!-- 关键修复：添加 :key="replayKey" 强制组件重新渲染 -->
        <battle-process
          v-if="currentReplayRecordings.length > 0"
          :recordings="currentReplayRecordings"
          :max-health-map="maxHealthMap"
          :key="replayKey"
        ></battle-process>
        <div v-else class="empty-replay">
          <Icon type="ios-film-outline" size="48" />
          <p>暂无回放数据</p>
          <p v-if="debugInfo" style="font-size: 12px; color: #999; margin-top: 10px;">{{ debugInfo }}</p>
        </div>
      </div>
    </div>

    <!-- 战斗日志弹窗 -->
    <Modal
      v-model="replayLogModal"
      title="战斗日志"
      :width="800"
      footer-hide
      transfer
    >
      <battle-process
        v-if="currentReplayRecordings.length > 0"
        :recordings="currentReplayRecordings"
        :max-health-map="maxHealthMap"
        :key="'modal-' + replayKey"
      ></battle-process>
    </Modal>

    <!-- DPS 统计 Modal -->
    <Modal
      v-model="dpsModalVisible"
      title="DPS 统计面板"
      :width="960"
      footer-hide
      transfer
      class-name="dps-modal-wrapper"
    >
      <div v-if="dpsStats.totalRounds > 0" class="dps-panel">
        <div class="dps-summary-bar">
          <Tag color="blue">总回合数 {{ dpsStats.totalRounds }}</Tag>
          <Tag color="green">我方总伤害 {{ formatNumber(dpsStats.allyTotalDamage) }}</Tag>
          <Tag color="orange">敌方总伤害 {{ formatNumber(dpsStats.enemyTotalDamage) }}</Tag>
        </div>
        <div class="dps-section">
          <div class="dps-section-title">我方</div>
          <table class="dps-table">
            <thead>
              <tr>
                <th>角色</th>
                <th>总伤害</th>
                <th>普攻伤害</th>
                <th>技能伤害</th>
                <th>反击伤害</th>
                <th>持续伤害</th>
                <th>生命恢复</th>
                <th>获得护盾</th>
                <th>吸血回血</th>
                <th>暴击次数</th>
                <th>连击伤害</th>
                <th>攻击次数</th>
                <th>均伤/次</th>
                <th>DPS</th>
                <th>承伤</th>
                <th>技能</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="unit in dpsStats.allies">
                <tr :key="'ally-' + unit.name" class="ally-row">
                  <td class="unit-name" :class="{ 'zero-dmg': unit.totalDamage === 0 }">{{ unit.name }}</td>
                  <td class="num">{{ formatNumber(unit.totalDamage) }}</td>
                  <td class="num">{{ formatNumber(unit.normalDamage) }}</td>
                  <td class="num">{{ formatNumber(unit.skillDamage) }}</td>
                  <td class="num">{{ formatNumber(unit.counterDamage) }}</td>
                  <td class="num">{{ formatNumber(unit.dotDamage) }}</td>
                  <td class="num heal">{{ formatNumber(unit.healing) }}</td>
                  <td class="num">{{ formatNumber(unit.shield) }}</td>
                  <td class="num heal">{{ formatNumber(unit.lifeSteal) }}</td>
                  <td class="num">{{ unit.critCount }}</td>
                  <td class="num">{{ formatNumber(unit.comboDamage) }}</td>
                  <td class="num">{{ unit.attackCount }}</td>
                  <td class="num">{{ unit.avgDamage }}</td>
                  <td class="num dps-val">{{ unit.dps }}</td>
                  <td class="num">{{ formatNumber(unit.damageReceived) }}</td>
                  <td>
                    <span
                      v-if="Object.keys(unit.skills).length"
                      class="skill-toggle"
                      @click="toggleSkillExpand(unit.name)"
                    >{{ isSkillExpanded(unit.name) ? '收起' : Object.keys(unit.skills).length + '个' }}</span>
                    <span v-else class="no-skill">-</span>
                  </td>
                </tr>
                <tr v-if="isSkillExpanded(unit.name) && Object.keys(unit.skills).length" :key="'ally-skill-' + unit.name" class="skill-detail-row">
                  <td colspan="16">
                    <table class="skill-sub-table">
                      <thead>
                        <tr>
                          <th>技能名</th>
                          <th>技能伤害</th>
                          <th>连击伤害</th>
                          <th>总伤害</th>
                          <th>吸血</th>
                          <th>恢复</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(sk, skName) in unit.skills" :key="skName">
                          <td class="skill-name-cell">{{ skName }}</td>
                          <td class="num">{{ formatNumber(sk.damage - sk.comboDamage) }}</td>
                          <td class="num">{{ formatNumber(sk.comboDamage) }}</td>
                          <td class="num">{{ formatNumber(sk.damage) }}</td>
                          <td class="num heal">{{ formatNumber(sk.lifeSteal) }}</td>
                          <td class="num heal">{{ formatNumber(sk.healing) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </template>
              <tr v-if="dpsStats.allies.length === 0">
                <td colspan="16" class="empty-cell">无我方单位数据</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="dps-section">
          <div class="dps-section-title">敌方</div>
          <table class="dps-table">
            <thead>
              <tr>
                <th>角色</th>
                <th>总伤害</th>
                <th>普攻伤害</th>
                <th>技能伤害</th>
                <th>反击伤害</th>
                <th>持续伤害</th>
                <th>生命恢复</th>
                <th>获得护盾</th>
                <th>吸血回血</th>
                <th>暴击次数</th>
                <th>连击伤害</th>
                <th>攻击次数</th>
                <th>均伤/次</th>
                <th>DPS</th>
                <th>承伤</th>
                <th>技能</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="unit in dpsStats.enemies">
                <tr :key="'enemy-' + unit.name" class="enemy-row">
                  <td class="unit-name" :class="{ 'zero-dmg': unit.totalDamage === 0 }">{{ unit.name }}</td>
                  <td class="num">{{ formatNumber(unit.totalDamage) }}</td>
                  <td class="num">{{ formatNumber(unit.normalDamage) }}</td>
                  <td class="num">{{ formatNumber(unit.skillDamage) }}</td>
                  <td class="num">{{ formatNumber(unit.counterDamage) }}</td>
                  <td class="num">{{ formatNumber(unit.dotDamage) }}</td>
                  <td class="num heal">{{ formatNumber(unit.healing) }}</td>
                  <td class="num">{{ formatNumber(unit.shield) }}</td>
                  <td class="num heal">{{ formatNumber(unit.lifeSteal) }}</td>
                  <td class="num">{{ unit.critCount }}</td>
                  <td class="num">{{ formatNumber(unit.comboDamage) }}</td>
                  <td class="num">{{ unit.attackCount }}</td>
                  <td class="num">{{ unit.avgDamage }}</td>
                  <td class="num dps-val">{{ unit.dps }}</td>
                  <td class="num">{{ formatNumber(unit.damageReceived) }}</td>
                  <td>
                    <span
                      v-if="Object.keys(unit.skills).length"
                      class="skill-toggle"
                      @click="toggleSkillExpand(unit.name)"
                    >{{ isSkillExpanded(unit.name) ? '收起' : Object.keys(unit.skills).length + '个' }}</span>
                    <span v-else class="no-skill">-</span>
                  </td>
                </tr>
                <tr v-if="isSkillExpanded(unit.name) && Object.keys(unit.skills).length" :key="'enemy-skill-' + unit.name" class="skill-detail-row">
                  <td colspan="16">
                    <table class="skill-sub-table">
                      <thead>
                        <tr>
                          <th>技能名</th>
                          <th>技能伤害</th>
                          <th>连击伤害</th>
                          <th>总伤害</th>
                          <th>吸血</th>
                          <th>恢复</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(sk, skName) in unit.skills" :key="skName">
                          <td class="skill-name-cell">{{ skName }}</td>
                          <td class="num">{{ formatNumber(sk.damage - sk.comboDamage) }}</td>
                          <td class="num">{{ formatNumber(sk.comboDamage) }}</td>
                          <td class="num">{{ formatNumber(sk.damage) }}</td>
                          <td class="num heal">{{ formatNumber(sk.lifeSteal) }}</td>
                          <td class="num heal">{{ formatNumber(sk.healing) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </template>
              <tr v-if="dpsStats.enemies.length === 0">
                <td colspan="16" class="empty-cell">无敌方单位数据</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="dps-empty">
        <Icon type="ios-pulse-outline" size="48" />
        <p>暂无战斗数据</p>
      </div>
    </Modal>
  </div>
</template>

<script>
import battleProcess from "./battleProcess.vue";

export default {
  name: 'BattleRecords',
  components: {battleProcess },
  props: {
    // 是否深色主题
    isDark: {
      type: Boolean,
      default: false
    },
    // 自动战斗状态
    autoCombatStatus: {
      type: Object,
      default: () => ({
        running: false,
        currentCount: 0,
        maxCount: 99999,
        mapId: null,
        mapName: "",
        winCount: 0,
        loseCount: 0,
        winRate: "0%",
        totalDropGold: 0,
        totalDropExp: 0,
        goldPerHour: 0,
        dropItemsDesc: "无",
      })
    },
    // 战斗历史记录
    battleHistory: {
      type: Array,
      default: () => []
    },
    // 最近战斗摘要（从接口获取）
    recentSummaries: {
      type: Array,
      default: () => []
    },
    // 最新回放记录
    latestRecordForReplay: {
      type: Object,
      default: null
    },
    replayBattleOptions: {
      type: Array,
      default: () => []
    },
    replaySelectedIndex: {
      type: Number,
      default: 0
    },
    villageMessages: {
      type: Array,
      default: () => []
    },
    currentUser: {
      type: Object,
      default: () => ({})
    },
    defaultAvatar: {
      type: String,
      default: ''
    },
    monsterList: {
      type: Array,
      default: () => []
    },
    gameAmryList: {
      type: Array,
      default: () => []
    },
    gameCharacterVO: {
      type: Array,
      default: () => []
    },
    gamePetVOList: {
      type: Array,
      default: () => []
    },
    recording: {
      type: Array,
      default: () => []
    },
    latestSummary: {
      type: Object,
      default: null
    },
    mapLootsList: {
      type: Array,
      default: () => []
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    externalView: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      // 当前视图: 'list' | 'summary' | 'replay'
      currentView: 'summary',
      refreshing: false,
      // 新增：消息状态管理
      localVillageMessages: [],   // 本地缓存消息，避免直接修改 props
      historyLoaded: false,       // 是否已加载历史消息
      loadingHistory: false,      // 历史消息加载状态
      maxMessageCount: 50,         // 最大保留消息数（与后端限制一致）
      selectedHistoryIndex: -1,
      selectedHistory: null,
      currentReplayRecordings: [],
      originalReplayRecordings: [],
      replayMonsters: [],
      replayAlliesDisplay: [],
      historyChatInput: '',
      replayKey: 0,              // 新增：用于强制刷新 battle-process
      replayLogModal: false,
      autoPlayOnRefresh: false,   // 新增：标记是否需要在刷新后自动播放
      debugInfo: '',
      replayCursor: 0,
      replayTimer: null,
      replayPlaying: false,
      replaySpeed: 4,
      replaySpeedOptions: [2, 4, 'all'],
      dpsModalVisible: false,
      expandedSkillUnits: {}
    }
  },

  computed: {
    hasSummaries() {
      return this.recentSummaries && this.recentSummaries.length > 0
    },
    normalizedRecentSummaries() {
      return (this.recentSummaries || [])
        .filter(summary => summary != null)
        .map((summary, index) => {
          const parsed = this.parseSummaryEntry(summary)
          return {
            ...parsed,
            key: `summary-${index}-${parsed.key || ''}`,
            isLatest: index === 0
          }
        })
    },
    showReplayPicker() {
      return Array.isArray(this.replayBattleOptions)
        && this.replayBattleOptions.length > 1
        && this.currentView !== 'summary'
    },

    replayTitle() {
      if (this.selectedHistory) {
        return `${this.selectedHistory.timestamp} - ${this.selectedHistory.result}`
      }
      return '战斗回放'
    },

    filteredVillageMessages() {
      return this.localVillageMessages
        .filter(msg => this.shouldDisplayChatMessage(msg))
        .slice()
        .reverse()
    },
    replaySourceRecord() {
      if (this.selectedHistory) {
        return this.selectedHistory.rawRecord || this.selectedHistory
      }
      return this.resolveReplayRecord(this.latestRecordForReplay)
    },
    // matchedMapLoot() {
    //   const mapName = this.normalizeMapName(this.autoCombatStatus && this.autoCombatStatus.mapName)
    //   if (!mapName) return null

    //   const list = Array.isArray(this.mapLootsList) ? this.mapLootsList : []
    //   const exactMatch = list.find(item => this.normalizeMapName(item.mapName) === mapName)
    //   if (exactMatch) return exactMatch

    //   return list.find(item => {
    //     const candidate = this.normalizeMapName(item.mapName)
    //     return candidate && (candidate.includes(mapName) || mapName.includes(candidate))
    //   }) || null
    // },
    // compactMapDropItems() {
    //   const items = this.matchedMapLoot && Array.isArray(this.matchedMapLoot.itemsVoList)
    //     ? this.matchedMapLoot.itemsVoList
    //     : []

    //   const groupedItems = new Map()

    //   items.forEach((item, index) => {
    //     const itemName = ((item && item.itemName) || '').trim()
    //     if (!itemName) return

    //     if (!groupedItems.has(itemName)) {
    //       groupedItems.set(itemName, {
    //         name: itemName,
    //         qualities: [],
    //         color: Number(item.color) || 0,
    //         order: index
    //       })
    //     }

    //     const current = groupedItems.get(itemName)
    //     const qualityLabel = this.getMapDropQualityLabel(item)
    //     if (qualityLabel && !current.qualities.includes(qualityLabel)) {
    //       current.qualities.push(qualityLabel)
    //     }

    //     current.color = Math.max(current.color || 0, Number(item.color) || 0)
    //   })

    //   return Array.from(groupedItems.values())
    //     .sort((a, b) => a.order - b.order)
    //     .map(item => ({
    //       ...item,
    //       displayName: item.qualities.length > 1
    //         ? `${item.name}（${item.qualities.join('|')}）`
    //         : item.name
    //     }))
    // },
    mergedAllies() {
      const challengers = (this.gameAmryList || []).map((item, index) => ({
        ...item,
        _key: `amry-${item.accountId || index}`,
        _group: '挑战',
        _name: item.name || '挑战者',
        _currentHp: Math.max(item.formerHealth || 0, 0),
        _maxHp: item.maxLife || item.formerHealth || 0
      }))
      const chars = (this.gameCharacterVO || []).map((item, index) => ({
        ...item,
        _key: `char-${index}`,
        _group: '角色',
        _name: item.name || '角色',
        _currentHp: Math.max(item.health || 0, 0),
        _maxHp: item.maxLife || item.health || 0
      }))
      const pets = (this.gamePetVOList || []).map((item, index) => ({
        ...item,
        _key: `pet-${item.auraId || index}`,
        _group: '真灵',
        _name: item.auraName || '真灵',
        _currentHp: Math.max(item.auraLife || 0, 0),
        _maxHp: item.maxLife || item.auraLife || 0
      }))
      return [...challengers, ...chars, ...pets]
    },
    maxHealthMap() {
      const map = {}
      const addEntry = (name, hp) => {
        if (!name || hp <= 0) return
        if (!map[name]) map[name] = hp
        // 也用简短名注册（去掉等级前缀和身份后缀）
        const short = name.replace(/^Lv\.\d+\s+/, '').replace(/\s+[甲乙丙丁戊己庚辛壬癸]$/, '')
        if (short !== name && !map[short]) map[short] = hp
      }
      // 玩家: health
      ;(this.gameCharacterVO || []).forEach(item => {
        addEntry(item.name, Number(item.health) || Number(item.maxLife) || 0)
      })
      // 宠物: life（注意 auraLife 可能为0，实际血量在 life 字段）
      ;(this.gamePetVOList || []).forEach(item => {
        const hp = Number(item.life) || Number(item.auraLife) || Number(item.maxLife) || Number(item.health) || Number(item.formerHealth) || 0
        if (item.auraName) addEntry(item.auraName, hp)
        if (item.name && item.name !== item.auraName) addEntry(item.name, hp)
      })
      // 怪物: life（优先用 replayMonsters，回放时 monsterList prop 可能不是同一场战斗）
      const monsters = (this.replayMonsters && this.replayMonsters.length > 0)
        ? this.replayMonsters : (this.monsterList || [])
      monsters.forEach(item => {
        addEntry(item.name, Number(item.life) || Number(item.maxLife) || 0)
      })
      // 回放角色数据（_maxHp 由 normalizeReplayAlly 计算，已正确处理 life 字段）
      ;(this.replayAlliesDisplay || []).forEach(item => {
        const name = item._name || item.name || item.auraName
        const hp = Number(item._maxHp) || Number(item.life) || Number(item.maxLife) || Number(item.health) || Number(item.auraLife) || 0
        addEntry(name, hp)
      })
      return map
    },
    dpsStats() {
      const records = this.originalReplayRecordings
      if (!records || !records.length) {
        return { allies: [], enemies: [], totalRounds: 0, allyTotalDamage: 0, enemyTotalDamage: 0 }
      }

      const totalRounds = records.reduce((max, r) => Math.max(max, r.round || 0), 0)
      const unitMap = {}

      const initUnit = (name, identity) => {
        if (!unitMap[name]) {
          unitMap[name] = {
            name, identity,
            totalDamage: 0, normalDamage: 0, skillDamage: 0,
            counterDamage: 0, dotDamage: 0,
            healing: 0, shield: 0, lifeSteal: 0,
            critCount: 0, comboDamage: 0,
            attackCount: 0, skillCount: 0,
            damageReceived: 0,
            skills: {}
          }
        }
      }

      this.replayMonsters.forEach(m => { if (m.name) initUnit(m.name, 1) })
      this.replayAlliesDisplay.forEach(a => { if (a._name) initUnit(a._name, 0) })

      const processRecord = (rec) => {
        const hurt = this.parseHurtValue(rec.hurt || rec.hurtNum)
        const hurtCombo = this.parseHurtCombo(rec.hurt || rec.hurtNum)
        const isDamage = rec.hurtType !== 5 && rec.hurtType !== 8

        if (rec.attacker && hurt > 0) {
          const u = unitMap[rec.attacker]
          if (!u) return

          const ls = Number(rec.lifeStealAmount) || 0

          // 技能统计（跨所有hurtType）
          if (rec.isSkill == 1) {
            u.skillCount++
            const sn = (rec.skillName || '未知').replace(/[\[\]]/g, '')
            if (!u.skills[sn]) u.skills[sn] = { damage: 0, comboDamage: 0, lifeSteal: 0, healing: 0 }
            if (rec.hurtType === 5) {
              u.skills[sn].healing += hurt
            } else {
              u.skills[sn].damage += hurt
              if (hurtCombo > 0) u.skills[sn].comboDamage += hurtCombo
            }
            if (ls > 0) u.skills[sn].lifeSteal += ls
          }

          if (rec.hurtType === 5) {
            u.healing += hurt
          } else if (rec.hurtType === 8) {
            u.shield += hurt
          } else {
            u.totalDamage += hurt
            u.attackCount++

            if (rec.hurtType === 4) {
              u.counterDamage += hurt
            } else if (rec.hurtType === 3) {
              u.dotDamage += hurt
            } else if (rec.isSkill == 1) {
              u.skillDamage += hurt - hurtCombo
            } else {
              u.normalDamage += hurt - hurtCombo
            }

            if (hurtCombo > 0) u.comboDamage += hurtCombo
            if (rec.isCritical == 1) u.critCount++
            if (ls > 0) u.lifeSteal += ls
          }
        }

        if (rec.hinjured && hurt > 0 && isDamage) {
          const t = unitMap[rec.hinjured]
          if (t) t.damageReceived += hurt
        }
      }

      records.forEach(r => {
        if (r.attacker) initUnit(r.attacker, r.identity || 0)
        if (r.hinjured) initUnit(r.hinjured, 0)

        // 初始化连击子目标
        const subs = Array.isArray(r.hinjuredConmbatList) ? r.hinjuredConmbatList : []
        subs.forEach(sub => {
          if (sub.attacker) initUnit(sub.attacker, sub.identity || 0)
          if (sub.hinjured) initUnit(sub.hinjured, 0)
        })
      })

      records.forEach(r => {
        processRecord(r)
        // 处理连击/多目标子伤害
        const subs = Array.isArray(r.hinjuredConmbatList) ? r.hinjuredConmbatList : []
        subs.forEach(sub => processRecord(sub))
      })

      const toStats = u => ({
        ...u,
        avgDamage: u.attackCount > 0 ? Math.round(u.totalDamage / u.attackCount) : 0,
        dps: totalRounds > 0 ? (u.totalDamage / totalRounds).toFixed(1) : 0,
      })

      const allies = Object.values(unitMap).filter(u => u.identity === 0).map(toStats).sort((a, b) => b.totalDamage - a.totalDamage)
      const enemies = Object.values(unitMap).filter(u => u.identity !== 0).map(toStats).sort((a, b) => b.totalDamage - a.totalDamage)
      const allyTotalDamage = allies.reduce((s, u) => s + u.totalDamage, 0)
      const enemyTotalDamage = enemies.reduce((s, u) => s + u.totalDamage, 0)

      return { allies, enemies, totalRounds, allyTotalDamage, enemyTotalDamage }
    }
  },
  watch: {
    villageMessages: {
      immediate: true,
      handler(messages) {
        const list = Array.isArray(messages) ? messages : []
        this.localVillageMessages = list.slice(0, this.maxMessageCount)
      }
    },
    latestRecordForReplay: {
      immediate: true,
      handler(val) {
        const record = this.resolveReplayRecord(val)
        if (this.hasReplayCombat(val)) {
          this.prepareReplayData(val)

          // 如果标记了自动播放，则在下一个 tick 切换到回放视图
          if (this.autoPlayOnRefresh && this.originalReplayRecordings.length > 0) {
            this.$nextTick(() => {
              this.selectedHistory = {
                timestamp: record.timestamp || new Date().toLocaleString('zh-CN'),
                result: (record && record.result) || '最新战斗',
                recordings: this.originalReplayRecordings,
                rawRecord: record
              }
              this.replayKey++  // 强制刷新组件
              this.currentView = 'replay'
              this.autoPlayOnRefresh = false
              this.startReplayPlayback()
            })
          }
        }
      }
    },
    externalView: {
      immediate: true,
      handler(val) {
        if (!val) return
        if (val === 'summary') {
          this.currentView = 'summary'
        }
      }
    }
  },
  beforeDestroy() {
    this.stopReplayTimer();
  },

  methods: {
     // 点击加载历史
  async loadHistory() {
    if (this.historyLoaded || this.loadingHistory) return
    await this.loadMoreHistory()
    this.historyLoaded = true
  },
     // 判断是否需要显示时间分隔线（新的一天）
  showTimeDivider(index) {
    if (index === 0) return true
    
    const currentMsg = this.filteredVillageMessages[index]
    const prevMsg = this.filteredVillageMessages[index - 1]
    
    return !this.isSameDay(currentMsg.timestamp, prevMsg.timestamp)
  },

  isSameDay(time1, time2) {
    const d1 = new Date(time1)
    const d2 = new Date(time2)
    return d1.getFullYear() === d2.getFullYear() &&
           d1.getMonth() === d2.getMonth() &&
           d1.getDate() === d2.getDate()
  },

  formatDividerTime(timestamp) {
    const date = new Date(timestamp)
    const now = new Date()
    
    if (this.isSameDay(date, now)) return '今天'
    
    const yesterday = new Date(now)
    yesterday.setDate(yesterday.getDate() - 1)
    if (this.isSameDay(date, yesterday)) return '昨天'
    
    return `${date.getMonth() + 1}月${date.getDate()}日`
  },

  // 改进时间格式化
  formatChatTime(timestamp) {
    if (!timestamp) return ''
    const date = new Date(timestamp)
    const now = new Date()
    
    // 如果是今天的消息，只显示时间
    if (this.isSameDay(date, now)) {
      return date.toLocaleTimeString('zh-CN', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: false 
      })
    }
    
    // 否则显示完整日期时间
    return date.toLocaleString('zh-CN', {
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    })
  },
    // 加载更多历史消息（分页）
  async loadMoreHistory() {
    if (this.loadingHistory) return
    
    this.loadingHistory = true
    try {
      const oldestMsg = this.localVillageMessages[this.localVillageMessages.length - 1]
      const beforeTime = oldestMsg ? oldestMsg.timestamp : Date.now()
      
      // 触发父组件加载更多历史消息
      this.$emit('load-more-history', {
        channel: '桑林村村口',
        beforeTime: beforeTime,
        limit: this.maxMessageCount
      })
    } finally {
      this.loadingHistory = false
    }
  },

  // 添加新消息到列表（自动去重和截断）
  addMessageToHistory(newMessage) {
    // 检查是否已存在（根据 timestamp 和 from 判断）
    const exists = this.localVillageMessages.some(msg => 
      msg.timestamp === newMessage.timestamp && 
      msg.from === newMessage.from &&
      msg.text === newMessage.text
    )
    
    if (!exists) {
      this.localVillageMessages.unshift(newMessage)
      
      // 限制最大数量，防止内存溢出
      if (this.localVillageMessages.length > this.maxMessageCount) {
        this.localVillageMessages = this.localVillageMessages.slice(0, this.maxMessageCount)
      }
      
      // 如果是当前用户发送的消息，自动滚动到底部
      if (newMessage.from === this.currentUser.account) {
        this.$nextTick(() => {
          this.scrollRecordsChatToBottom()
        })
      }
    }
  },

  // 批量添加历史消息（从 WebSocket 加载）
  prependHistoryMessages(messages) {
    const existingKeys = new Set(
      this.localVillageMessages.map(msg => `${msg.timestamp}-${msg.from}`)
    )
    
    const newMessages = messages.filter(msg => 
      !existingKeys.has(`${msg.timestamp}-${msg.from}`)
    )
    
    this.localVillageMessages = [...newMessages, ...this.localVillageMessages]
    if (this.localVillageMessages.length > this.maxMessageCount) {
      this.localVillageMessages = this.localVillageMessages.slice(0, this.maxMessageCount)
    }
  },
    // 统一解析回放记录：兼容单对象、{record}、{records}、数组
    resolveReplayRecords(source) {
      if (!source) return []
      if (Array.isArray(source)) return source.filter(Boolean)
      if (Array.isArray(source.records)) return source.records.filter(Boolean)
      if (source.record) return this.resolveReplayRecords(source.record)
      return [source]
    },
    // 获取最后一场记录，作为回放头部信息展示
    resolveReplayRecord(source) {
      const records = this.resolveReplayRecords(source)
      return records.length > 0 ? records[records.length - 1] : null
    },
    // 判断是否存在可回放的 combatInfo
    hasReplayCombat(source) {
      const records = this.resolveReplayRecords(source)
      return records.some(item => Array.isArray(item && item.combatInfo) && item.combatInfo.length > 0)
    },
    // 将 1~3 场战斗日志合并为统一回放流，round 连续递增
    buildReplayRecordings(records) {
      const normalizedRecords = Array.isArray(records) ? records : []
      const result = []
      let roundOffset = 0

      // 使用 maxHealthMap computed（已在 resetReplayStage 之后，数据正确）
      const map = this.maxHealthMap || {}
      const lookupMaxHp = (name) => {
        if (!name) return 0
        let hp = map[name]
        if (hp > 0) return hp
        const short = name.replace(/^Lv\.\d+\s+/, '').replace(/\s+[甲乙丙丁戊己庚辛壬癸]$/, '')
        if (short !== name) {
          hp = map[short]
          if (hp > 0) return hp
        }
        const normName = short.replace(/\s+/g, '')
        for (const key in map) {
          const normKey = key.replace(/\s+/g, '')
          if (normName.includes(normKey) || normKey.includes(normName)) {
            return map[key]
          }
        }
        return 0
      }

      normalizedRecords.forEach((record, battleIndex) => {
        const combatInfoList = Array.isArray(record && record.combatInfo) ? record.combatInfo : []
        let maxRoundInBattle = 0

        combatInfoList.forEach((info, index) => {
          const currentRound = Number(info && info.round) || Math.floor(index / 2) + 1
          maxRoundInBattle = Math.max(maxRoundInBattle, currentRound)

          const attacker = (info && (info.attacker || info.attackerName)) || ''
          const hinjured = (info && (info.hinjured || info.targetName)) || ''

          result.push({
            ...(info || {}),
            type: info && info.hurtType === 5 ? 'gain' : ((info && info.type) || 'combat'),
            round: currentRound + roundOffset,
            battleIndex: battleIndex + 1,
            attacker,
            identity: (info && info.identity) || 0,
            hinjured,
            hurt: (info && (info.hurt || info.damage || info.hurtNum)) || 0,
            hurtType: info && info.hurtType,
            isSkill: info && info.isSkill,
            skillName: info && info.skillName,
            isCritical: info && info.isCritical,
            surplusHealth: info && info.surplusHealth,
            attElement: info && info.attElement,
            maxHealth: lookupMaxHp(hinjured),
            attackerMaxHealth: lookupMaxHp(attacker),
          })
        })

        roundOffset += maxRoundInBattle
      })

      return result
    },
    toArray(value) {
      if (!value) return []
      return Array.isArray(value) ? value : [value]
    },
    readNumericField(item, fields, fallback = null) {
      if (!item) return fallback

      for (const field of fields) {
        const rawValue = item[field]
        if (rawValue === '' || rawValue === null || rawValue === undefined) {
          continue
        }

        const value = Number(rawValue)
        if (Number.isFinite(value)) {
          return value
        }
      }

      return fallback
    },
    getMonsterCurrentHp(item) {
      return Math.max(this.readNumericField(item, ['life', 'health'], 0), 0)
    },
    getMonsterMaxHp(item) {
      const maxHp = this.readNumericField(item, ['maxLife', 'maxHealth', 'formerLife', 'life', 'health'], 0)
      return Math.max(maxHp, this.getMonsterCurrentHp(item), 0)
    },
    getAllyCurrentHp(item) {
      return Math.max(this.readNumericField(item, ['formerHealth', 'health', 'auraLife', 'life'], 0), 0)
    },
    getAllyMaxHp(item) {
      const maxHp = this.readNumericField(item, ['maxLife', 'maxHealth', 'formerHealth', 'health', 'auraLife', 'life'], 0)
      return Math.max(maxHp, this.getAllyCurrentHp(item), 0)
    },
    formatTooltipStat(item, fields) {
      const value = this.readNumericField(item, fields)
      return value === null ? '--' : value
    },
    formatTooltipPercent(item, fields) {
      const value = this.readNumericField(item, fields)
      if (value === null) return '--'

      const percentValue = Math.abs(value) <= 1 ? value * 100 : value
      return `${percentValue.toFixed(2)}%`
    },
    formatAttackDisplay(item, minFields = ['attackMin'], maxFields = ['attackMax'], fallbackFields = ['physicalAttack']) {
      const attackMin = this.readNumericField(item, minFields)
      const attackMax = this.readNumericField(item, maxFields)

      if (attackMin !== null && attackMax !== null) {
        return attackMin === attackMax ? attackMin : `${attackMin}-${attackMax}`
      }

      const fallback = this.readNumericField(item, fallbackFields)
      return fallback === null ? '--' : fallback
    },
    getReplaySkillSummary(item) {
      if (!item) return ''

      const rawSkills = []
      const sourceLists = [item.characterSkills, item.gameSkillRedisVo, item.skillsList]

      sourceLists.forEach(list => {
        if (Array.isArray(list)) {
          rawSkills.push(...list.filter(Boolean))
        }
      })

      if (!rawSkills.length) return ''

      const normalized = rawSkills
        .map((skill, index) => {
          const order = Number(
            skill.skillOrder
            || skill.gckSkillOrder
            || skill.order
            || (index + 1)
          )
          const gameSkill = skill.gameSkill || {}
          const name = skill.skillName || skill.name || gameSkill.gSkillName || gameSkill.skillName || ''

          return {
            order,
            name: String(name || '').trim()
          }
        })
        .filter(skill => skill.order >= 1 && skill.order <= 5 && skill.name)
        .sort((a, b) => a.order - b.order)

      if (!normalized.length) return ''

      return normalized
        .slice(0, 5)
        .map(skill => `${skill.order}号位+${skill.name}`)
        .join(' / ')
    },
    formatReplayUnitStatus(item) {
      if (!item) return '--'

      if (item._group === '真灵') {
        const auraStatus = Number(item.auraStatus)
        if (auraStatus === 1) return '出战'
        if (auraStatus === 0) return '休息'
      }

      const buffs = this.parseReplayBuffNames(item)
      return buffs.length ? buffs.join('、') : '--'
    },
    parseReplayBuffNames(item) {
      const sources = [item && item.activeBuffList, item && item.monBuffer]
      const names = []

      sources.forEach(source => {
        if (!source) return
        try {
          const parsed = typeof source === 'string' ? JSON.parse(source) : source
          const list = Array.isArray(parsed) ? parsed : [parsed]
          list.forEach(buff => {
            const name = buff && (buff.name || buff.buffName || buff.desc)
            if (name && !names.includes(name)) {
              names.push(name)
            }
          })
        } catch (err) {
          // Ignore invalid buff payloads and fall back to basic status text.
        }
      })

      return names
    },
    normalizeMapName(name) {
      return ((name || '') + '').replace(/\s+/g, '').trim()
    },
    getMapDropQualityLabel(item) {
      if (!item) return ''
      return item.ship || this.getMapDropQualityName(item.color)
    },
    getMapDropQualityName(color) {
      const qualityMap = {
        1: '破损',
        2: '普通',
        3: '良品',
        4: '上品',
        5: '绝品',
        6: '灵宝',
        7: '秘宝'
      }
      return qualityMap[Number(color)] || ''
    },
    getMapDropItemColor(color) {
      const colorMap = {
        1: '#8c94a4',
        2: '#879f1e',
        3: '#078599',
        4: '#036cbe',
        5: '#801DAE',
        6: '#9e0e42',
        7: '#FFA631'
      }
      return colorMap[Number(color)] || (this.isDark ? '#d7deed' : '#515a6e')
    },
    handleMapDropPopoverShow() {
      if (!this.autoCombatStatus || !this.autoCombatStatus.mapName) return
      if (Array.isArray(this.mapLootsList) && this.mapLootsList.length > 0) return
      this.$emit('ensure-map-loots', this.autoCombatStatus.mapName)
    },
    buildMergedAllies(source) {
      const base = source || {}
      const challengers = this.toArray(base.gameAmryList).map((item, index) => ({
        ...item,
        _key: `amry-${item.accountId || item.id || index}`,
        _group: '挑战',
        _name: item.name || '挑战者',
        _currentHp: this.getAllyCurrentHp(item),
        _maxHp: this.getAllyMaxHp(item)
      }))
      const chars = this.toArray(base.gameCharacterVO).map((item, index) => ({
        ...item,
        _key: `char-${item.id || index}`,
        _group: '角色',
        _name: item.name || '角色',
        _currentHp: this.getAllyCurrentHp(item),
        _maxHp: this.getAllyMaxHp(item)
      }))
      const pets = this.toArray(base.gamePetVOList || base.gamePetVO).map((item, index) => ({
        ...item,
        _key: `pet-${item.auraId || item.id || index}`,
        _group: '真灵',
        _name: item.auraName || item.name || '真灵',
        _currentHp: this.getAllyCurrentHp(item),
        _maxHp: this.getAllyMaxHp(item)
      }))
      return [...challengers, ...chars, ...pets]
    },
    deepClone(value) {
      return JSON.parse(JSON.stringify(value || []))
    },
    normalizeReplayMonster(item) {
      const currentHp = this.getMonsterCurrentHp(item)
      const maxHp = this.getMonsterMaxHp(item)
      return {
        ...item,
        life: maxHp > 0 ? maxHp : currentHp,
        maxLife: Math.max(maxHp, currentHp, 0)
      }
    },
    normalizeReplayAlly(item) {
      const currentHp = this.getAllyCurrentHp(item)
      const maxHp = this.getAllyMaxHp(item)
      const normalizedCurrent = maxHp > 0 ? maxHp : currentHp
      const normalized = {
        ...item,
        _currentHp: normalizedCurrent,
        _maxHp: Math.max(maxHp, currentHp, 0)
      }

      if (Object.prototype.hasOwnProperty.call(normalized, 'formerHealth')) {
        normalized.formerHealth = normalizedCurrent
      }
      if (Object.prototype.hasOwnProperty.call(normalized, 'health')) {
        normalized.health = normalizedCurrent
      }
      if (Object.prototype.hasOwnProperty.call(normalized, 'auraLife')) {
        normalized.auraLife = normalizedCurrent
      }

      return normalized
    },
    resetReplayStage(record) {
      const source = record || this.replaySourceRecord || {}
      const sourceMonsters = Array.isArray(source.gameMonList)
        ? source.gameMonList
        : Array.isArray(source.monsterList)
          ? source.monsterList
          : this.monsterList

      let sourceAllies = this.buildMergedAllies(source)
      if (sourceAllies.length === 0) {
        sourceAllies = this.buildMergedAllies({
          gameAmryList: this.gameAmryList,
          gameCharacterVO: this.gameCharacterVO,
          gamePetVOList: this.gamePetVOList
        })
      }

      this.replayMonsters = this.deepClone(sourceMonsters).map(item => this.normalizeReplayMonster(item)).slice(0, 5)
      this.replayAlliesDisplay = this.deepClone(sourceAllies).map(item => this.normalizeReplayAlly(item)).slice(0, 5)
      this.currentReplayRecordings = []
      this.replayCursor = 0
    },
    stopReplayTimer() {
      if (this.replayTimer) {
        clearTimeout(this.replayTimer)
        this.replayTimer = null
      }
      this.replayPlaying = false
    },
    startReplayPlayback() {
      if (this.originalReplayRecordings.length === 0) {
        return
      }
      if (this.replayCursor >= this.originalReplayRecordings.length) {
        this.resetReplayStage(this.replaySourceRecord)
      }
      this.replayPlaying = true
      this.scheduleNextReplayStep()
    },
    scheduleNextReplayStep() {
      if (!this.replayPlaying) {
        return
      }
      if (this.replayCursor >= this.originalReplayRecordings.length) {
        this.stopReplayTimer()
        return
      }

      if (this.replaySpeed === 'all') {
        while (this.replayCursor < this.originalReplayRecordings.length) {
          this.stepReplayForward(false)
        }
        this.stopReplayTimer()
        return
      }
      const delay = Math.max(1500 / this.replaySpeed, 250)
      if (this.replayTimer) {
        clearTimeout(this.replayTimer)
      }
      this.replayTimer = setTimeout(() => {
        this.stepReplayForward(true)
        if (this.replayPlaying) {
          this.scheduleNextReplayStep()
        }
      }, delay)
    },
    toggleReplayPlayback() {
      if (this.replayPlaying) {
        this.stopReplayTimer()
        return
      }
      this.startReplayPlayback()
    },
    setReplaySpeed(speed) {
      this.replaySpeed = speed
      if (this.replayPlaying) {
        this.scheduleNextReplayStep()
      }
    },
    restartReplay() {
      this.stopReplayTimer()
      this.resetReplayStage(this.replaySourceRecord)
      this.replayKey++
      this.startReplayPlayback()
    },
    replayUntilCursor(cursor) {
      this.stopReplayTimer()
      this.resetReplayStage(this.replaySourceRecord)
      const targetCursor = Math.max(0, Math.min(cursor, this.originalReplayRecordings.length))
      for (let index = 0; index < targetCursor; index++) {
        const record = this.originalReplayRecordings[index]
        this.applyReplayRecord(record)
        this.currentReplayRecordings.push(record)
      }
      this.replayCursor = targetCursor
      this.replayKey++
    },
    stepReplayBackward() {
      if (this.replayCursor <= 0) {
        return
      }
      this.replayUntilCursor(this.replayCursor - 1)
    },
    stepReplayForward(fromAutoPlay = false) {
      if (this.replayCursor >= this.originalReplayRecordings.length) {
        this.stopReplayTimer()
        return
      }

      const record = this.originalReplayRecordings[this.replayCursor]
      this.applyReplayRecord(record)
      this.currentReplayRecordings.push(record)
      this.replayCursor += 1

      if (this.replayCursor >= this.originalReplayRecordings.length && fromAutoPlay) {
        this.stopReplayTimer()
      }
    },
    findReplayUnitByName(name) {
      if (!name) return null

      const monster = this.replayMonsters.find(item => item.name === name)
      if (monster) {
        return { unit: monster, group: 'monster' }
      }

      const ally = this.replayAlliesDisplay.find(item =>
        item._name === name || item.name === name || item.auraName === name
      )
      if (ally) {
        return { unit: ally, group: 'ally' }
      }

      return null
    },
    applyReplayHpToUnit(name, hp) {
      if (!name) return

      const numericHp = Number(hp)
      if (!Number.isFinite(numericHp)) return

      const targetHp = Math.max(numericHp, 0)
      const targetEntry = this.findReplayUnitByName(name)
      if (!targetEntry) return

      if (targetEntry.group === 'monster') {
        this.$set(targetEntry.unit, 'life', targetHp)
        return
      }

      const ally = targetEntry.unit
      this.$set(ally, '_currentHp', targetHp)
      if (Object.prototype.hasOwnProperty.call(ally, 'formerHealth')) {
        this.$set(ally, 'formerHealth', targetHp)
      }
      if (Object.prototype.hasOwnProperty.call(ally, 'health')) {
        this.$set(ally, 'health', targetHp)
      }
      if (Object.prototype.hasOwnProperty.call(ally, 'auraLife')) {
        this.$set(ally, 'auraLife', targetHp)
      }
      if (Object.prototype.hasOwnProperty.call(ally, 'life')) {
        this.$set(ally, 'life', targetHp)
      }
    },
    applyReplayRecord(record) {
      if (!record || record.type === 'result') {
        return
      }

      if (record.hinjured && record.surplusHealth !== '' && record.surplusHealth !== null && record.surplusHealth !== undefined) {
        this.applyReplayHpToUnit(record.hinjured, record.surplusHealth)
      }

      const hpCost = Number(record.hpCost)
      if (record.attacker && Number.isFinite(hpCost) && hpCost > 0) {
        const attackerEntry = this.findReplayUnitByName(record.attacker)
        if (attackerEntry && attackerEntry.group === 'ally') {
          this.applyReplayHpToUnit(record.attacker, attackerEntry.unit._currentHp - hpCost)
        }
      }

      const lifeStealAmount = Number(record.lifeStealAmount)
      if (record.attacker && Number.isFinite(lifeStealAmount) && lifeStealAmount > 0) {
        const attackerEntry = this.findReplayUnitByName(record.attacker)
        if (attackerEntry && attackerEntry.group === 'ally') {
          const nextHp = Math.min(attackerEntry.unit._currentHp + lifeStealAmount, attackerEntry.unit._maxHp || attackerEntry.unit._currentHp + lifeStealAmount)
          this.applyReplayHpToUnit(record.attacker, nextHp)
        }
      }

      const extraTargets = Array.isArray(record.hinjuredConmbatList) ? record.hinjuredConmbatList : []
      extraTargets.forEach(target => {
        if (!target) return
        const targetName = target.hinjured || target.targetName || target.name
        const targetHp = target.surplusHealth
        if (targetName && targetHp !== '' && targetHp !== null && targetHp !== undefined) {
          this.applyReplayHpToUnit(targetName, targetHp)
        }
      })

      const attackerSurplusHealth = record.attackerSurplusHealth
      if (record.attacker && attackerSurplusHealth !== '' && attackerSurplusHealth !== null && attackerSurplusHealth !== undefined) {
        this.applyReplayHpToUnit(record.attacker, attackerSurplusHealth)
      }
    },
    requestRefresh(payload = {}) {
      return new Promise((resolve, reject) => {
        this.$emit('refresh', {
          ...payload,
          resolve,
          reject
        })
      })
    },
    // 返回列表
    backToList() {
      this.stopReplayTimer()
      this.currentView = 'summary'
      this.$emit('view-change', 'summary')
      this.selectedHistoryIndex = -1
      this.selectedHistory = null
      this.currentReplayRecordings = []
      this.originalReplayRecordings = []
      this.replayMonsters = []
      this.replayAlliesDisplay = []
      this.replayCursor = 0
    },
    
    // 显示摘要列表
    showSummaries() {
      this.currentView = 'summary'
      this.$emit('view-change', 'summary')
      this.$emit('refresh') // 通知父组件刷新数据
    },
    
    // 显示最新回放
    showLatestReplay() {
      if (this.latestRecordForReplay && this.latestRecordForReplay.record) {
        const record = this.latestRecordForReplay.record
        
        // 准备回放数据
        this.prepareReplayData(record)
        
        // 关键：设置 selectedHistory，这样 replayTitle 才能正确显示
        this.selectedHistory = {
          timestamp: record.timestamp || new Date().toLocaleString('zh-CN'),
          result: record.result || '最新战斗',
          recordings: this.originalReplayRecordings,
          rawRecord: record  // 保存原始记录引用
        }
        
        // 强制刷新 battle-process 组件
        this.replayKey++
        
        // 切换到回放视图
        this.currentView = 'replay'
        this.$emit('view-change', 'replay')
      } else {
        this.$Message.info('暂无回放数据')
      }
    },
    
     // 刷新并播放最新战斗
     async refreshAndPlayLatest() {
      this.refreshing = true
      this.autoPlayOnRefresh = true  // 设置自动播放标记
      
      try {
        // 触发父组件刷新数据
        this.$emit('refresh')
        this.$Message.success('已刷新数据')
      } catch (err) {
        this.$Message.error('刷新失败')
        this.autoPlayOnRefresh = false
      } finally {
        this.refreshing = false
      }
    },
    
    // 刷新数据
    async refreshData() {
      this.refreshing = true
      try {
        await this.$emit('refresh')
        this.$Message.success('数据已刷新')
      } catch (err) {
        this.$Message.error('刷新失败')
      } finally {
        this.refreshing = false
      }
    },
    
    // 选择历史记录
    selectHistory(index) {
      this.selectedHistoryIndex = index
    },
    
    // 回放历史记录
    replayBattleHistory(record) {
      this.selectedHistory = record
      this.selectedHistoryIndex = this.battleHistory.indexOf(record)
      this.prepareReplayData(record.rawRecord || record)
      this.replayKey++
      this.currentView = 'replay'
      this.$nextTick(() => {
        this.startReplayPlayback()
      })
    },
    
    // 重播当前记录
    replayCurrentRecord() {
      this.replayKey++  // 关键：强制刷新组件以重新播放
      
      if (this.selectedHistory && this.selectedHistory.rawRecord) {
        this.prepareReplayData(this.selectedHistory.rawRecord)
      } else if (this.latestRecordForReplay && this.latestRecordForReplay.record) {
        this.prepareReplayData(this.latestRecordForReplay.record)
      }
      this.$nextTick(() => {
        this.startReplayPlayback()
      })
    },
    
    // 格式化数字
    emitChatMessage() {
      const text = (this.historyChatInput || '').trim()
      if (!text) {
        this.$Message.warning('请输入消息内容')
        return
      }

      this.$emit('send-chat-message', text)
      this.historyChatInput = ''
      this.$nextTick(() => {
        this.scrollRecordsChatToBottom()
      })
    },

    shouldDisplayChatMessage(msg) {
      if (!msg) return false
      if (msg.type === 'system') return false

      const text = this.getChatDisplayText(msg)
      if (!text) return false

      const hiddenPatterns = ['连接成功', 'HeartBeat', '进入了书信阁', '登录', '上线']
      return !hiddenPatterns.some(pattern => text.includes(pattern))
    },

    getChatDisplayName(msg) {
      return msg.fromNickname || msg.from || '匿名'
    },

    getChatDisplayText(msg) {
      return ((msg && (msg.text || msg.content)) || '').trim()
    },

    formatNumber(num) {
      if (!num) return '0'
      if (num >= 10000) return (num / 10000).toFixed(1) + 'w'
      if (num >= 1000) return (num / 1000).toFixed(1) + 'k'
      return num.toString()
    },
    getHpPercent(current, max) {
      const safeMax = Number(max) || 0
      if (safeMax <= 0) return 0
      const safeCurrent = Math.max(Number(current) || 0, 0)
      return Number(((safeCurrent / safeMax) * 100).toFixed(2))
    },
    formatPercent(value) {
      const num = Number(value || 0)
      return `${(num * 100).toFixed(2)}%`
    },

    parseSummaryEntry(summary) {
      if (summary && typeof summary === 'object' && !Array.isArray(summary)) {
        const displayText = summary.content || summary.summary || summary.resultDesc || ''
        return {
          key: summary.id || summary.combatIndex || `${summary.timestamp || ''}-${displayText}`,
          displayText,
          timeText: this.resolveSummaryTimeText(summary),
          statusClass: this.resolveSummaryStatusClass(displayText, summary.success),
        }
      }

      const text = String(summary || '').trim()
      const timeMatch = text.match(/(\d{2}:\d{2}:\d{2})$/)
      return {
        key: `${text}-${timeMatch ? timeMatch[1] : ''}`,
        displayText: timeMatch ? text.replace(/\s*\d{2}:\d{2}:\d{2}$/, '') : text,
        timeText: timeMatch ? timeMatch[1] : '',
        statusClass: this.resolveSummaryStatusClass(text)
      }
    },

    resolveSummaryStatusClass(text, success) {
      if (typeof success === 'boolean') {
        return success ? 'success' : 'fail'
      }
      return String(text || '').includes('战斗成功') ? 'success' : 'fail'
    },

    resolveSummaryTimeText(summary) {
      if (!summary) return ''
      if (summary.summaryTimeText) return summary.summaryTimeText
      if (summary.timestamp) return this.formatTime(summary.timestamp)

      const text = summary.content || summary.summary || summary.resultDesc || ''
      const timeMatch = String(text).match(/(\d{2}:\d{2}:\d{2})$/)
      return timeMatch ? timeMatch[1] : ''
    },
    
    // 格式化时间
    formatTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      if (Number.isNaN(date.getTime())) {
        return String(timestamp)
      }
      return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    },
    
    formatChatTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      const now = new Date()

      if (date.toDateString() === now.toDateString()) {
        return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' })
      }

      const yesterday = new Date(now)
      yesterday.setDate(yesterday.getDate() - 1)
      if (date.toDateString() === yesterday.toDateString()) {
        return '昨天'
      }

      return `${date.getMonth() + 1}-${date.getDate()}`
    },

    getBattleResultColor(result) {
      const colors = { '胜利': 'success', '失败': 'error', '平局': 'warning' }
      return colors[result] || 'default'
    },
    
   prepareReplayData(record) {
      if (!record || !record.combatInfo) {
        this.currentReplayRecordings = []
        return
      }

      this.currentReplayRecordings = record.combatInfo.map((info, index) => ({
        type: info.hurtType === 5 ? 'gain' : 'combat',
        round: info.round || Math.floor(index / 2) + 1,
        attacker: info.attacker || info.attackerName,
        identity: info.identity || 0,
        hinjured: info.hinjured || info.targetName,
        hurt: info.hurt || info.damage || 0,
        hurtType: info.hurtType,
        isSkill: info.isSkill,
        skillName: info.skillName,
        isCritical: info.isCritical,
        surplusHealth: info.surplusHealth,
        attElement: info.attElement,
      }))
    },
    
    // 导出当前日志
    exportCurrentLog() {
      if (this.currentReplayRecordings.length === 0) {
        this.$Message.warning('没有可导出的记录')
        return
      }
      
      const logText = this.currentReplayRecordings
        .map((r, i) => {
          if (r.type === 'combat') {
            return `第${i+1}回合: ${r.attacker} 攻击 ${r.hinjured} 造成 ${r.hurt} 伤害`
          } else if (r.type === 'gain') {
            return `第${i+1}回合: ${r.attacker} 治疗 ${r.hinjured} 回复 ${r.hurt} 血量`
          }
          return `第${i+1}回合: ${r.content || ''}`
        })
        .join('\n')
      
      const blob = new Blob([logText], { type: 'text/plain' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `战斗记录_${new Date().toLocaleString().replace(/[/:\\s]/g, '_')}.txt`
      link.click()
      URL.revokeObjectURL(url)
      
      this.$Message.success('日志已导出')
    },
    
    // 清空历史
    clearAllHistory() {
      this.$Modal.confirm({
        title: '确认清空',
        content: '确定要清空所有战斗历史记录吗？',
        onOk: () => {
          this.$emit('clear-history')
          this.selectedHistory = null
          this.selectedHistoryIndex = -1
          this.$Message.success('历史记录已清空')
        }
      })
    },
    
    // 停止自动战斗
    scrollRecordsChatToBottom() {
      const container = this.$refs.recordsChatMessages
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },

    showSummaries() {
      this.currentView = 'summary'
      this.$emit('refresh', { sourceView: 'summary', includeLatestReplay: true })
    },

    showLatestReplay() {
      const record = this.resolveReplayRecord(this.latestRecordForReplay)
      if (!this.hasReplayCombat(this.latestRecordForReplay)) {
        this.$Message.info('暂无回放数据')
        return
      }

      this.prepareReplayData(this.latestRecordForReplay)
      this.selectedHistory = {
        timestamp: record.timestamp || new Date().toLocaleString('zh-CN'),
        result: record.result || '最新战斗',
        recordings: this.originalReplayRecordings,
        rawRecord: record
      }
      this.replayKey++
      this.currentView = 'replay'
      this.$nextTick(() => {
        this.startReplayPlayback()
      })
    },

    async refreshAndPlayLatest() {
      if (this.refreshing) return

      this.refreshing = true
      this.autoPlayOnRefresh = true

      try {
        const result = await this.requestRefresh({ sourceView: 'replay', includeLatestReplay: true })
        if (!result || !result.hasReplay) {
          this.autoPlayOnRefresh = false
          this.$Message.warning('暂无最新战斗回放')
          return
        }

        this.$Message.success('已刷新最新战斗回放')
      } catch (err) {
        this.autoPlayOnRefresh = false
        this.$Message.error('刷新失败')
      } finally {
        this.refreshing = false
      }
    },

    async refreshData() {
      if (this.refreshing) return

      this.refreshing = true
      try {
        await this.requestRefresh({ sourceView: this.currentView, includeLatestReplay: true })
        this.$Message.success('数据已刷新')
      } catch (err) {
        this.$Message.error('刷新失败')
      } finally {
        this.refreshing = false
      }
    },

    replayCurrentRecord() {
      this.replayKey++

      if (this.selectedHistory && this.selectedHistory.rawRecord) {
        this.prepareReplayData(this.selectedHistory.rawRecord)
      } else {
        const record = this.resolveReplayRecord(this.latestRecordForReplay)
        if (record) {
          this.prepareReplayData(record)
        }
      }
      this.$nextTick(() => {
        if (this.originalReplayRecordings.length > 0) {
          this.startReplayPlayback()
        }
      })
    },

    prepareReplayData(record) {
      const records = this.resolveReplayRecords(record)
      if (records.length === 0) {
        this.stopReplayTimer()
        this.originalReplayRecordings = []
        this.currentReplayRecordings = []
        return
      }

      this.stopReplayTimer()

      // 先从源记录中提取单位数据，确保 maxHealth 使用正确的数据
      const sourceRecord = this.resolveReplayRecord(record)
      this.resetReplayStage(sourceRecord)

      // resetReplayStage 已填充 replayMonsters/replayAlliesDisplay，
      // buildReplayRecordings 内部的 maxHealthMap computed 会使用这些数据
      this.originalReplayRecordings = this.buildReplayRecordings(records)
    },

    stopAutoCombat() {
      this.$emit('stop-auto-combat')
    },
    selectReplayIndex(index) {
      this.$emit('select-replay-index', index)
    },
    toggleSkillExpand(unitName) {
      this.$set(this.expandedSkillUnits, unitName, !this.expandedSkillUnits[unitName])
    },
    isSkillExpanded(unitName) {
      return !!this.expandedSkillUnits[unitName]
    },
    parseHurtValue(val) {
      if (val === undefined || val === null || val === '') return 0
      if (typeof val === 'number') return Math.max(val, 0)
      const str = String(val).trim()
      if (str.includes(',')) {
        return str.split(',').reduce((sum, part) => {
          const cleaned = part.replace(/[^\d.-]/g, '')
          const n = Number(cleaned)
          return sum + (Number.isFinite(n) ? Math.max(n, 0) : 0)
        }, 0)
      }
      const n = Number(str.replace(/[^\d.-]/g, ''))
      return Number.isFinite(n) ? Math.max(n, 0) : 0
    },
    parseHurtCombo(val) {
      if (val === undefined || val === null || val === '') return 0
      if (typeof val === 'number') return 0
      const str = String(val).trim()
      if (!str.includes('⭐')) return 0
      if (str.includes(',')) {
        return str.split(',').reduce((sum, part) => {
          if (!part.includes('⭐')) return sum
          const cleaned = part.replace(/[^\d.-]/g, '')
          const n = Number(cleaned)
          return sum + (Number.isFinite(n) ? Math.max(n, 0) : 0)
        }, 0)
      }
      // 单个连击值，如 "⭐11390"
      const cleaned = str.replace(/[^\d.-]/g, '')
      const n = Number(cleaned)
      return Number.isFinite(n) ? Math.max(n, 0) : 0
    }
  }
}
</script>

<style scoped>
.battle-records-container {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e8eaec;
}

.battle-records-container.dark {
  background: #151728;
  border-color: rgba(73, 117, 212, 0.2);
}

/* 头部 */
.records-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  background: rgba(45, 140, 240, 0.1);
  border-bottom: 1px solid #e8eaec;
  flex-shrink: 0;
}

.dark .records-header {
  background: rgba(73, 117, 212, 0.15);
  border-color: rgba(73, 117, 212, 0.2);
}
.replay-picker {
  margin-left: 8px;
}

.replay-picker-inline {
  margin-left: 0;
}

.replay-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid #e8eaec;
  background: rgba(45, 140, 240, 0.04);
}

.dark .replay-toolbar {
  border-bottom-color: rgba(73, 117, 212, 0.2);
  background: rgba(255, 255, 255, 0.03);
}

.replay-toolbar-left,
.replay-toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.replay-progress {
  font-size: 12px;
  color: #808695;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.back-btn {
  margin-right: 5px;
}

.header-title {
  font-size: 15px;
  font-weight: 600;
  color: #515a6e;
}

.dark .header-title {
  color: #9c9cab;
}

.auto-tag {
  animation: pulse 2s infinite;
}

.header-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.clear-btn {
  margin-left: 5px;
}

/* 视图面板 */
.view-panel {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.battle-stage {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 12px 16px 10px;
  border-bottom: 1px dashed #e8eaec;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.02) 0%, rgba(0, 0, 0, 0) 100%);
}

.dark .battle-stage {
  border-color: rgba(73, 117, 212, 0.18);
  background: linear-gradient(180deg, rgba(73, 117, 212, 0.06) 0%, rgba(73, 117, 212, 0) 100%);
}

.battle-stage-replay {
  padding-bottom: 12px;
}

.stage-column {
  min-width: 0;
}

.stage-title {
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #808695;
  text-transform: uppercase;
}

.dark .stage-title {
  color: #9aa4bf;
}

.stage-list {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
}

.mud-line {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  min-height: 64px;
  padding: 8px 10px;
  border: 1px solid #d7dbe3;
  border-radius: 8px;
  background: rgba(45, 140, 240, 0.04);
}

.dark .mud-line {
  border-color: rgba(73, 117, 212, 0.24);
  background: rgba(73, 117, 212, 0.08);
}

.mud-line.defeated {
  opacity: 0.45;
}

.mud-name {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-size: 13px;
  color: #2f3640;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark .mud-name {
  color: #d7deed;
}

.mud-tag {
  flex-shrink: 0;
  font-size: 10px;
  color: #808695;
}

.mud-value {
  flex-shrink: 0;
  font-size: 12px;
  color: #808695;
  font-variant-numeric: tabular-nums;
}

.mud-progress {
  margin: 0;
}

.mud-progress >>> .ivu-progress-inner {
  height: 5px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.08);
}

.dark .mud-progress >>> .ivu-progress-inner {
  background: rgba(255, 255, 255, 0.08);
}

.battle-stage-status {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
}

.battle-stage-note {
  font-size: 12px;
  color: #2d8cf0;
}

.battle-stage-note-muted {
  color: #19be6b;
}

.mud-pop >>> .ivu-poptip-inner {
  border-radius: 8px;
}

.mud-pop >>> .ivu-poptip-body {
  font-family: "Courier New", "Microsoft YaHei", monospace;
}

.mud-pop-trigger,
.mud-pop-trigger >>> .ivu-poptip-rel {
  display: block;
  width: 100%;
}

.mud-detail {
  font-size: 12px;
  line-height: 1.7;
}

.mud-detail p {
  margin: 0;
}

.map-drop-trigger-tag {
  cursor: pointer;
}

.map-drop-trigger-text {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 2px;
  cursor: pointer;
}

.map-drop-pop >>> .ivu-poptip-inner {
  max-width: 360px;
  border-radius: 8px;
}

.map-drop-panel {
  max-width: 340px;
}

.map-drop-title {
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #515a6e;
}

.dark .map-drop-title {
  color: #d7deed;
}

.map-drop-list {
  display: block;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.45;
  max-width: 100%;
}

.map-drop-item {
  font-size: 12px;
  white-space: nowrap;
}

.map-drop-empty {
  font-size: 12px;
  color: #808695;
}

/* 列表视图 */
.list-view {
  padding: 0;
}

.list-stats {
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  font-size: 12px;
  color: #808695;
  border-bottom: 1px solid #e8eaec;
  background: rgba(0,0,0,0.02);
}

.dark .list-stats {
  border-color: rgba(73, 117, 212, 0.2);
  color: #808695;
}

.auto-info {
  color: #2d8cf0;
  font-weight: 500;
}

.history-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.live-record-panel {
  margin: 0 16px 12px;
  padding: 10px 0 0;
  border-top: 1px dashed #d7dbe3;
}

.dark .live-record-panel {
  border-color: rgba(73, 117, 212, 0.2);
}

.live-record-scroll {
  max-height: 240px;
  overflow-y: auto;
  padding-right: 4px;
}

.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid #e8eaec;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.dark .history-item {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(73, 117, 212, 0.2);
}

.history-item:hover {
  border-color: #2d8cf0;
  box-shadow: 0 2px 8px rgba(45, 140, 240, 0.1);
}

.dark .history-item:hover {
  background: rgba(73, 117, 212, 0.1);
  border-color: rgba(73, 117, 212, 0.4);
}

.history-item.active {
  border-color: #2d8cf0;
  background: rgba(45, 140, 240, 0.05);
}

@media (max-width: 768px) {
  .battle-stage {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 10px 12px 8px;
  }

  .stage-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
  }

  .mud-line {
    min-height: 58px;
    padding: 8px;
  }

  .mud-name {
    font-size: 12px;
  }

  .mud-value,
  .battle-stage-note {
    font-size: 11px;
  }
}

.records-chat-panel {
  flex-shrink: 0;
  min-height: 250px;
  max-height: clamp(220px, 38vh, 300px);
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  border-top: 1px dashed #d7dbe3;
  background: transparent;
}

.dark .records-chat-panel {
  border-color: rgba(73, 117, 212, 0.2);
}

.records-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 0 8px;
}

.dark .records-chat-header {
  background: transparent;
}

.records-chat-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}

.dark .records-chat-title {
  color: #c5cee0;
}

.records-chat-count {
  font-size: 12px;
  color: #808695;
}

.records-chat-messages {
  flex: 1;
  overflow-y: auto;
  max-height: clamp(150px, 28vh, 200px);
  padding: 4px 0;
  font-family: "Courier New", "Microsoft YaHei", monospace;
  background: transparent;
}

.records-chat-line {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0;
  margin-bottom: 4px;
  font-size: 13px;
  line-height: 1.65;
}

.records-chat-line.self .records-chat-name {
  color: #2d8cf0;
}

.records-chat-name {
  font-size: 12px;
  font-weight: 600;
  color: #515a6e;
  margin-right: 2px;
}

.dark .records-chat-name {
  color: #d7deed;
}

.records-chat-time {
  flex-shrink: 0;
  font-size: 11px;
  color: #999;
  margin-right: 8px;
}

.records-chat-text {
  font-size: 13px;
  color: #333;
  white-space: pre-wrap;
  word-break: break-word;
}

.dark .records-chat-text {
  color: #c5cee0;
}

.records-chat-empty {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #999;
  font-size: 12px;
}

.records-chat-input {
  padding: 10px 0 0;
  border-top: 1px dashed #e8eaec;
  background: transparent;
}

.dark .records-chat-input {
  background: transparent;
  border-color: rgba(73, 117, 212, 0.2);
}

.records-chat-prepend {
  display: flex;
  align-items: center;
}

.records-chat-input >>> .ivu-input {
  border-radius: 18px;
}

.records-chat-input >>> .ivu-btn {
  border-radius: 0 18px 18px 0;
}

.item-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.item-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.time {
  font-size: 13px;
  color: #515a6e;
  font-weight: 500;
}

.dark .time {
  color: #9c9cab;
}

.item-stats {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #808695;
}

.item-stats span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.item-actions {
  opacity: 0;
  transition: opacity 0.2s;
}

.history-item:hover .item-actions {
  opacity: 1;
}

.action-btn {
  min-width: 60px;
}

/* 摘要视图 */
.summary-view {
  padding: 0;
}

.summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  font-size: 13px;
  color: #808695;
  border-bottom: 1px solid #e8eaec;
  background: rgba(0,0,0,0.02);
}

.dark .summary-header {
  border-color: rgba(73, 117, 212, 0.2);
  color: #808695;
}

.summary-list {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}

.summary-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  margin-bottom: 10px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #e8eaec;
  transition: all 0.2s;
}

.dark .summary-item {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(73, 117, 212, 0.2);
}

.summary-item.latest {
  border-color: #2d8cf0;
  background: rgba(45, 140, 240, 0.05);
}

.dark .summary-item.latest {
  border-color: rgba(73, 117, 212, 0.5);
  background: rgba(73, 117, 212, 0.1);
}

.summary-item.success {
  border-left: 3px solid #19be6b;
}

.summary-item.fail {
  border-left: 3px solid #ed4014;
}

.summary-index {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.05);
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
  color: #808695;
  flex-shrink: 0;
}

.dark .summary-index {
  background: rgba(255, 255, 255, 0.1);
  color: #9c9cab;
}

.summary-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.summary-result {
  display: flex;
  align-items: center;
  gap: 8px;
}

.result-text {
  font-size: 14px;
  font-weight: 600;
}

.result-text.success {
  color: #19be6b;
}

.result-text.fail {
  color: #ed4014;
}

.summary-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-row {
  display: flex;
  gap: 12px;
  font-size: 12px;
  flex-wrap: wrap;
}

.detail-row .label {
  color: #808695;
  min-width: 60px;
}

.dark .detail-row .label {
  color: #808695;
}

.detail-row .value {
  color: #515a6e;
  font-weight: 500;
}

.dark .detail-row .value {
  color: #9c9cab;
}

.detail-row .value.health {
  color: #ed4014;
}

.detail-row .value.mana {
  color: #2d8cf0;
}

.detail-row .value.exp {
  color: #ff9900;
}

.detail-row .value.items {
  color: #19be6b;
}

.detail-row.items {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px dashed #e8eaec;
}

.dark .detail-row.items {
  border-color: rgba(73, 117, 212, 0.2);
}

.summary-time {
  font-size: 11px;
  color: #808695;
  flex-shrink: 0;
}

.auto-control {
  padding: 12px 16px;
  border-top: 1px solid #e8eaec;
  background: rgba(45, 140, 240, 0.05);
}

.dark .auto-control {
  border-color: rgba(73, 117, 212, 0.2);
  background: rgba(73, 117, 212, 0.1);
}

/* 回放视图 */
.replay-view {
  padding: 0;
  display: flex;
  flex-direction: column;
}

.replay-header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: rgba(0,0,0,0.02);
  border-bottom: 1px solid #e8eaec;
  flex-shrink: 0;
}

.dark .replay-header-bar {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(73, 117, 212, 0.2);
}

.replay-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #515a6e;
}

.dark .replay-info {
  color: #9c9cab;
}

.replay-content-box {
  flex: 1;
  min-height: 0;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 12px;
  background: #fff;
}

.dark .replay-content-box {
  background: #151728;
}

.replay-content-box--pc-adaptive >>> .battle-log {
  max-height: 220px;
  overflow-x: auto;
}

/* 战斗日志弹窗内的日志区域 */
>>> .ivu-modal-body .battle-log {
  max-height: 70vh;
  overflow-y: auto;
}

.empty-replay {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #808695;
}

/* 空状态 */
.empty-state {
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #808695;
  gap: 8px;
}

.dark .empty-state {
  color: #808695;
}

.empty-state p {
  font-size: 14px;
  margin: 0;
}

.sub-text {
  font-size: 12px;
  opacity: 0.7;
}

/* 动画 */
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

/* 滚动条 */
.history-list::-webkit-scrollbar,
.summary-list::-webkit-scrollbar,
.records-chat-messages::-webkit-scrollbar {
  width: 6px;
}

.history-list::-webkit-scrollbar-track,
.summary-list::-webkit-scrollbar-track,
.records-chat-messages::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dark .history-list::-webkit-scrollbar-track,
.dark .summary-list::-webkit-scrollbar-track,
.dark .records-chat-messages::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.history-list::-webkit-scrollbar-thumb,
.summary-list::-webkit-scrollbar-thumb,
.records-chat-messages::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dark .history-list::-webkit-scrollbar-thumb,
.dark .summary-list::-webkit-scrollbar-thumb,
.dark .records-chat-messages::-webkit-scrollbar-thumb {
  background: rgba(73, 117, 212, 0.5);
}

/* 响应式 */
@media (max-width: 768px) {
  .battle-records-container {
    height: auto;
    min-height: 60vh;
  }

  .view-panel {
    min-height: 0;
  }

  .records-header {
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px 12px;
  }
  
  .header-actions {
    width: 100%;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
  
  .history-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .item-actions {
    opacity: 1;
    width: 100%;
  }
  
  .action-btn {
    width: 100%;
  }
  
  .summary-item {
    flex-direction: column;
    gap: 8px;
  }
  
  .summary-time {
    align-self: flex-end;
  }

  .records-chat-panel {
    min-height: 250px;
    max-height: none;
  }

  .records-chat-header,
  .records-chat-input {
    padding-left: 0;
    padding-right: 0;
  }

  .records-chat-messages {
    max-height: 200px;
  }
  
  .replay-header-bar {
    flex-wrap: wrap;
    gap: 8px;
  }
}
/* 列表视图中的统计信息 */
.combat-stats-detail {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-left: auto;
}

/* 统计概览面板 */
.stats-overview {
  padding: 12px 16px;
  background: rgba(45, 140, 240, 0.05);
  border-bottom: 1px solid #e8eaec;
}

.dark .stats-overview {
  background: rgba(73, 117, 212, 0.1);
  border-color: rgba(73, 117, 212, 0.2);
}

.stats-card {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
}

.stats-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
}

.stats-item.wide {
  min-width: 120px;
  margin-left: auto;
}

.stats-value {
  font-size: 18px;
  font-weight: 700;
  color: #515a6e;
}

.dark .stats-value {
  color: #c5cee0;
}

.stats-value.success {
  color: #19be6b;
}

.stats-value.fail {
  color: #ed4014;
}

.stats-value.rate {
  color: #2d8cf0;
}

.stats-value.gold {
  color: #ff9900;
}

.stats-value.exp {
  color: #9c9cab;
}

.stats-value.map {
  font-size: 14px;
  color: #8054ff;
}

.stats-label {
  font-size: 11px;
  color: #808695;
  margin-top: 2px;
}

.dark .stats-label {
  color: #808695;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .combat-stats-detail {
    width: 100%;
    margin-left: 0;
    margin-top: 8px;
  }
  
  .stats-card {
    justify-content: center;
  }
  
  .stats-item.wide {
    margin-left: 0;
    width: 100%;
    margin-top: 8px;
  }
}
/* 历史消息加载提示 */
.history-loading {
  text-align: center;
  padding: 10px;
  color: #808695;
  font-size: 12px;
}

/* 时间分隔线 */
.time-divider {
  text-align: center;
  margin: 12px 0;
  position: relative;
}

.time-divider::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 1px;
  background: #e8eaec;
}

.time-divider span {
  background: #fff;
  padding: 0 12px;
  color: #808695;
  font-size: 11px;
  position: relative;
  z-index: 1;
}

.dark .time-divider span {
  background: #151728;
}

/* 历史消息样式（从服务器加载的旧消息） */
.records-chat-line.history {
  opacity: 0.8;
}

/* 系统消息样式 */
.records-chat-line.system {
  text-align: center;
  font-size: 12px;
  color: #808695;
  background: rgba(0,0,0,0.02);
  border-radius: 4px;
  padding: 4px 8px;
  margin: 4px 0;
}

/* 优化消息布局 */
.message-content {
  display: flex;
  align-items: baseline;
  gap: 4px;
  flex-wrap: wrap;
}

.records-chat-name {
  flex-shrink: 0;
  font-weight: 600;
  color: #515a6e;
}

.records-chat-line.self .records-chat-name {
  color: #2d8cf0;
}

.records-chat-text {
  word-break: break-word;
  line-height: 1.4;
}

/* ========== DPS 统计面板 ========== */
.dps-panel {
  max-height: 70vh;
  overflow-y: auto;
}

.dps-summary-bar {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 0 12px;
  border-bottom: 1px solid #e8eaec;
  margin-bottom: 12px;
}

.dark .dps-summary-bar {
  border-color: rgba(73, 117, 212, 0.2);
}

.dps-section {
  margin-bottom: 16px;
}

.dps-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #515a6e;
  margin-bottom: 8px;
  padding-left: 4px;
  border-left: 3px solid #2d8cf0;
}

.dark .dps-section-title {
  color: #d7deed;
  border-left-color: #4975d4;
}

.dps-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  table-layout: auto;
}

.dps-table thead th {
  background: rgba(45, 140, 240, 0.06);
  color: #515a6e;
  font-weight: 600;
  padding: 6px 4px;
  border-bottom: 2px solid #e8eaec;
  white-space: nowrap;
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 1;
}

.dark .dps-table thead th {
  background: rgba(73, 117, 212, 0.12);
  color: #c5cee0;
  border-bottom-color: rgba(73, 117, 212, 0.3);
}

.dps-table tbody td {
  padding: 5px 4px;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
}

.dark .dps-table tbody td {
  border-bottom-color: rgba(255, 255, 255, 0.05);
  color: #c5cee0;
}

.dps-table .unit-name {
  text-align: left;
  font-weight: 600;
  color: #2d8cf0;
  white-space: nowrap;
  min-width: 80px;
}

.dark .dps-table .unit-name {
  color: #5cadff;
}

.dps-table .unit-name.zero-dmg {
  color: #808695;
}

.dark .dps-table .unit-name.zero-dmg {
  color: #666;
}

.dps-table .num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  min-width: 50px;
}

.dps-table .num.heal {
  color: #19be6b;
}

.dps-table .num.dps-val {
  color: #ff9900;
  font-weight: 700;
}

.enemy-row .unit-name {
  color: #c62828 !important;
}

.dark .enemy-row .unit-name {
  color: #ff6e6e !important;
}

.skill-toggle {
  color: #2d8cf0;
  cursor: pointer;
  font-size: 11px;
  border-bottom: 1px dashed #2d8cf0;
}

.skill-toggle:hover {
  color: #57a3f3;
}

.no-skill {
  color: #c5c8ce;
  font-size: 11px;
}

.skill-detail-row td {
  padding: 0 !important;
  border-bottom: 2px solid #e8eaec !important;
}

.dark .skill-detail-row td {
  border-bottom-color: rgba(73, 117, 212, 0.3) !important;
}

.skill-sub-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  margin: 4px 0;
}

.skill-sub-table thead th {
  background: rgba(25, 190, 107, 0.08);
  color: #808695;
  font-weight: 500;
  padding: 3px 4px;
  font-size: 11px;
}

.dark .skill-sub-table thead th {
  background: rgba(25, 190, 107, 0.12);
  color: #9aa4bf;
}

.skill-sub-table tbody td {
  padding: 3px 4px;
  border-bottom: 1px solid #f5f5f5;
}

.dark .skill-sub-table tbody td {
  border-bottom-color: rgba(255, 255, 255, 0.04);
}

.skill-name-cell {
  text-align: left !important;
  color: #19be6b;
  padding-left: 12px !important;
}

.dps-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #808695;
}

.dps-empty p {
  margin-top: 12px;
  font-size: 14px;
}

.empty-cell {
  color: #c5c8ce;
  font-style: italic;
  padding: 12px !important;
}

.dps-modal-wrapper >>> .ivu-modal-body {
  padding: 16px 20px;
}
</style>

<style>
@media (max-width: 768px) {
  .dps-modal-wrapper .ivu-modal {
    width: 100vw !important;
    max-width: 100vw !important;
  }

  .dps-modal-wrapper .ivu-modal-body {
    padding: 8px !important;
    overflow-x: hidden !important;
  }

  .dps-panel {
    width: 100% !important;
  }

  .dps-summary-bar {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 6px !important;
  }

  .dps-summary-bar .ivu-tag {
    margin: 0 !important;
    text-align: center;
  }

  .dps-table {
    display: block !important;
    width: 100% !important;
    min-width: 0 !important;
  }

  .dps-table thead {
    display: none !important;
  }

  .dps-table tbody,
  .dps-table tr {
    display: block !important;
    width: 100% !important;
  }

  .dps-table tbody tr:not(.skill-detail-row) {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
    gap: 4px 8px;
    margin: 0 0 8px;
    padding: 9px !important;
    border: 1px solid #e8eaec;
    border-radius: 8px;
    background: #fff;
  }

  .dps-table tbody tr:not(.skill-detail-row) td {
    display: flex !important;
    justify-content: space-between;
    min-width: 0 !important;
    padding: 3px 0 !important;
    border: 0 !important;
    font-size: 12px;
  }

  .dps-table tbody tr:not(.skill-detail-row) td:nth-child(1) {
    grid-column: 1 / -1;
    font-size: 14px;
    font-weight: 700;
    border-bottom: 1px solid #e8eaec !important;
    padding-bottom: 6px !important;
  }

  .dps-table tbody tr:not(.skill-detail-row) td:nth-child(2)::before { content: '总伤害'; }
  .dps-table tbody tr:not(.skill-detail-row) td:nth-child(3)::before { content: '普攻'; }
  .dps-table tbody tr:not(.skill-detail-row) td:nth-child(4)::before { content: '技能'; }
  .dps-table tbody tr:not(.skill-detail-row) td:nth-child(14)::before { content: 'DPS'; }
  .dps-table tbody tr:not(.skill-detail-row) td:nth-child(15)::before { content: '承伤'; }
  .dps-table tbody tr:not(.skill-detail-row) td:nth-child(16)::before { content: '技能详情'; }

  .dps-table tbody tr:not(.skill-detail-row) td:nth-child(n+5):nth-child(-n+13) {
    display: none !important;
  }

  .dps-table tbody tr.skill-detail-row {
    margin: -4px 0 10px;
    padding: 6px !important;
    background: #f8faff;
    border-radius: 6px;
  }

  .skill-sub-table {
    display: block !important;
    width: 100% !important;
    min-width: 0 !important;
  }

  .skill-sub-table thead {
    display: none !important;
  }

  .skill-sub-table tbody,
  .skill-sub-table tr {
    display: block !important;
  }

  .skill-sub-table tr {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
    padding: 5px 0 !important;
    border-bottom: 1px dashed #dfe5ef;
  }

  .skill-sub-table td {
    display: flex !important;
    justify-content: space-between;
    border: 0 !important;
    padding: 2px !important;
    font-size: 11px;
  }

  .skill-sub-table td:nth-child(1) {
    grid-column: 1 / -1;
    font-weight: 600;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/BattleRecords.vue